export interface ExecuteRequest_t {
  type: "output/execute/wsExecuteRequest",
  payload: {
    channel: "stable",
    mode: "debug",
    edition: "2024",
    crateType: "bin" | "li",
    tests: boolean,
    code: String,
    backtrace: false,
  },
  meta: {
    websocket: true,
    sequenceNumber: number,
  }
}

export interface ConnectRequest_t {
  type: "websocket/connected",
  payload: { iAcceptThisIsAnUnsupportedApi: true },
  meta: { websocket: true, sequenceNumber: number },
}

export function makeConnectRequest(sequenceNumber: number): ConnectRequest_t {
  return {
    type: 'websocket/connected',
    payload: { iAcceptThisIsAnUnsupportedApi: true },
    meta: { websocket: true, sequenceNumber }
  };
}

export function makeExecuteRequest(
  code: String,
  backtrace: false,
  sequenceNumber: number,
  isTest: boolean,
): ExecuteRequest_t {
  return {
    type: "output/execute/wsExecuteRequest",
    payload: {
      channel: "stable",
      mode: "debug",
      edition: "2024",
      crateType: "bin",
      tests: isTest,
      code,
      backtrace,
    },
    meta: {
      websocket: true,
      sequenceNumber,
    }
  };
}

export function sendExecuteRequest(socket: WebSocket, sequenceNumber: number, code: string, isTest: boolean) {
  socket.send(JSON.stringify(makeExecuteRequest(code, false, sequenceNumber, isTest)));
}

export interface Meta_t { websocket: boolean, sequenceNumber: number };

export type Message_t = MessageEnum_t & { meta: Meta_t };

export type MessageEnum_t = {
  type: 'websocket/connected';
  payload: { iAcceptThisIsAnUnsupportedApi: boolean };
} | {
  type: 'featureFlags';
  payload: {};
} | {
  type: 'output/execute/wsExecuteBegin';
} | {
  type: 'output/execute/wsExecuteStatus';
  payload: { residentSetSizeBytes: number, totalTimeSecs: number };
} | {
  type: 'output/execute/wsExecuteStderr';
  payload: string;
} | {
  type: 'output/execute/wsExecuteStdout';
  payload: string;
} | {
  type: 'output/execute/wsExecuteEnd';
  payload: {
    success: boolean;
    exitDetail: string;
  }
}

export interface SocketState_t {
  sequenceNumber: number;
  messages: Message_t[];
  editorNameToSeqNumber: Record<string, number>;
}